import { render, staticRenderFns } from "./tubematerialselection.vue?vue&type=template&id=337c9875&"
import script from "./../../ts/articleattributes/tubematerialselection.ts?vue&type=script&lang=js&"
export * from "./../../ts/articleattributes/tubematerialselection.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports